import React from 'react';
import styles from './style.module.css';

const Pagination = ({ limit, totalCount, range, currentPage, onPageChange }) => {
    const totalPages = Math.ceil(totalCount / limit);

    const handlePageChange = (page) => {
        if (page > 0 && page <= totalPages) {
            onPageChange(page);
        }
    };

    const renderPagination = () => {
        const pages = [];
        let startPage = Math.max(1, currentPage - Math.floor(range / 2));
        let endPage = Math.min(startPage + range - 1, totalPages);

        if (endPage - startPage + 1 < range) {
            startPage = Math.max(1, endPage - range + 1);
        }

        for (let i = startPage; i <= endPage; i++) {
            pages.push(
                <button 
                    key={i} 
                    className={`btn btn-outline-primary btn-sm ${i === currentPage ? 'active' : ''}`} 
                    onClick={() => handlePageChange(i)}
                >
                    {i}
                </button>
            );
        }

        return pages;
    };

    return (
        <div className="d-flex align-items-center">
            <button 
                className="btn btn-outline-secondary btn-sm me-2" 
                disabled={currentPage === 1} 
                onClick={() => handlePageChange(currentPage - 1)}
            >
                &lt; Previous
            </button>
            <div className="btn-group">
                {renderPagination()}
            </div>
            <button 
                className="btn btn-outline-secondary btn-sm ms-2" 
                disabled={currentPage === totalPages} 
                onClick={() => handlePageChange(currentPage + 1)}
            >
                Next &gt;
            </button>
        </div>
    );
};

export default Pagination;
